<template>
  <component
    :is="isMobile ? 'VcInputBottomSheet' : 'VcInputPopover'"
    v-if="staffs.length > 1"
    v-model="showPopover"
    :bottom="58"
    :left="315"
    :close-on-click="false"
    persistent
    :ok-button-label="$t('common.dialog.done')"
    class="additional-staff"
    data-qa="additional-staff"
    @onCancelClicked="onCancel"
    @onOkClicked="handleSubmit">
    <template v-slot:activator="activatorObj">
      <v-btn v-bind="activatorObj"
             class="additional-staff__button"
             color="#F8F9FB"
             height="52"
             @click="showPopover = true">
        <template>
          <VcIcon>icon-add_event</VcIcon>
        </template>
      </v-btn>
    </template>
    <template>
      <AdditionalStaff
        :additional-staffs="currentAdditionalStaff"
        :current-staff-uid="currentStaffUid"
        :staffs="staffs"
        @change="changeAdditionalStaff"/>
    </template>
  </component>

  <component
    :is="isMobile ? 'VcBottomSheet' : 'VcPopover'"
    v-else
    v-model="showPopover"
    :bottom="58"
    :left="315"
    class="additional-staff-empty-state"
    data-qa="additional-staff-empty-state">
    <template v-slot:activator="activatorObj">
      <v-btn v-bind="activatorObj"
             class="additional-staff-empty-state__button"
             color="#F8F9FB"
             height="52"
             @click="showPopover = true">
        <template>
          <VcIcon>icon-add_event</VcIcon>
        </template>
      </v-btn>
    </template>
    <template>
      <VcLayout class="additional-staff-empty-state__popover" column>
        <VcEmptyState :button="$t('staff.staff_selection.new_staff')"
                      :image="require('@/assets/images/team_members.svg')"
                      :title="$t('staff.staff_selection.empty_state.title')"
                      subtitle=""
                      class="empty-state"
                      size="sm"
                      @click="addNewStaff"/>
        <VcLayout align-center column>
          <VcButton class="additional-staff-empty-state__popover__button"
                    color="white"
                    :label="$t('common.dialog.close')"
                    @click="showPopover = false">
          </VcButton>
        </VcLayout>
      </VcLayout>
    </template>
  </component>
</template>

<script>
import AdditionalStaff from "@/modules/bookings/components/AdditionalStaffDialog/components/additionalStaff";

export default {
  name: 'additionalStaffPopover',
  components: {
    AdditionalStaff,
  },
  props: {
    currentStaffUid: {
      type: String,
      required: true
    },
    additionalStaffs: {
      type: Array,
      default: () => []
    },
    staffs: {
      type: Array,
      default: () => [],
      validator: staff => staff.every(s => s.uid && s.label),
    },
  },
  data: () => ({
    showPopover: false,
    currentSelectedAdditionalStaff: [],
  }),
  methods: {
    onCancel() {
      this.showPopover = false;
      this.currentSelectedAdditionalStaff.forEach(additionalStaff => {
        additionalStaff.checked = this.additionalStaffs.includes(additionalStaff.uid);
      })
    },
    changeAdditionalStaff(selections) {
      this.currentSelectedAdditionalStaff = this.staffs.map(staff => ({...staff, checked: selections.some(selection => selection.uid === staff.uid)}))
    },
    handleSubmit() {
      this.showPopover = false
      this.$emit('submit', this.currentAdditionalStaff)
    },
    addNewStaff() {
      this.$track('New appointment - Create new staff click', {'Origin': 'additional staff empty state'})
      this.$frontageApi.send('add-new-staff')
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile
    },
    currentAdditionalStaff() {
      return this.currentSelectedAdditionalStaff.flatMap(staff => staff.checked ? [staff.uid] : [])
    },
    additionalStaffsUidMap() {
      return this.additionalStaffs.reduce((acc, currStaff) => {
        acc[currStaff] = true
        return acc
      }, {})
    },
  },
  watch: {
    additionalStaffs: {
      handler() {
        this.currentSelectedAdditionalStaff.forEach((current) => {
          current.checked = !!this.additionalStaffsUidMap[current.uid]
        })
      }
    }
  }
}

</script>

<style lang="scss" scoped>

.additional-staff, .additional-staff-empty-state {
  &__button {
    width: 44px;
    min-width: 44px !important;
    box-shadow: unset;
    color: #999999;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.additional-staff-empty-state {
  &__popover {
    padding-block: 40.5px;

    .VcEmptyState {
      ::v-deep {
        .VcImage.VcEmptyStateImage {
          margin-bottom: 16px;
        }

        .VcEmptyStateTitle {
          font-weight: 600;
          font-size: 13px;
          line-height: 20px;
          color: #212121;
        }

        .VcButton.VcEmptyStateButton {
          margin-block-start: 24px;
        }
      }
    }

    &__button {
      margin-block-start: 4px;
      color: #212121;
    }
  }
}
</style>
